/* stylelint-disable no-descending-specificity */
import styled, { css } from 'styled-components'
import { colors, spacing } from '@global/theme'

const Small = css`
  height: ${spacing.threeAndAHalf};
  padding: ${spacing.one} ${spacing.two};

  min-width: ${({ fixWidth }) => (fixWidth ? spacing.eight : '')};
`

const Medium = css`
  height: ${spacing.five};
  padding: ${spacing.one} ${spacing.two};

  min-width: ${({ fixWidth }) => (fixWidth ? spacing.eleven : '')};
`

const Large = css`
  height: ${spacing.fiveAndAHalf};
  padding: ${spacing.oneAndAHalf} ${spacing.twoAndAHalf};

  min-width: ${({ fixWidth }) => (fixWidth ? spacing.fifteen : '')};
`

const Solid = css`
  background-color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.15);

  > * {
    color: ${colors.background.regular};
  }

  &:disabled {
    cursor: inherit;
    box-shadow: none;
    background-color: ${({ color }) => (colors[color]?.disabled ?? colors.primary.disabled)};
    > * {
      color: ${colors.background.primary};
    }
  }

  &:hover:enabled {
    background-color: ${({ color }) => (colors[color]?.hover ?? colors.primary.hover)};
  }

  &:focus {
    background-color: ${({ color }) => (colors[color]?.focus ?? colors.primary.focus)};
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.12);
  }

  &:active:enabled {
    background-color: ${({ color }) => (colors[color]?.selected ?? colors.primary.selected)};
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.12);
  }
`

const Line = css`
  background-color: ${colors.background.regular};
  border: 1px solid ${colors.system.regular};

  > * {
    color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
  }

  &:disabled {
    cursor: inherit;
    box-shadow: none;
    background-color: ${({ color }) => (colors[color]?.disabled ?? colors.primary.disabled)};
    border: none;
    > * {
      color: ${colors.background.regular};
    }
  }

  &:hover:enabled {
    background-color: ${({ color }) => (colors[color]?.darker ?? colors.primary.darker)};
    border-color: ${({ color }) => (colors[color]?.hover ?? colors.primary.hover)};
    
    > * {
      color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
    }
  }

  &:focus {
    background-color: ${colors.background.regular};
    border-color: ${({ color }) => (colors[color]?.focus ?? colors.primary.focus)};
    /* outline-offset: 1px;
    outline: 2px solid ${({ color }) => (colors[color]?.dark ?? colors.primary.dark)}; */
    > * {
      color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
    }
  }

  &:active:enabled {
    background-color: ${({ color }) => (colors[color]?.darker ?? colors.primary.darker)};
    border: 2px solid ${colors.system.regular};
    outline: none;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.12);
    > * {
      color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
    }
  }
`

const Ghost = css`
  background-color:  ${colors.background.regular};
  border: 1px solid ${colors.contrast.disabled};
  > * {
    color: ${({ color }) => (colors[color]?.regular ?? colors.grays.dark)};
    
  }
  &:disabled {
    cursor: inherit;
    box-shadow: none;
    background-color: ${({ color }) => (colors[color]?.disabled ?? colors.primary.disabled)};
    border-color: ${({ color }) => (colors[color]?.disabled ?? colors.primary.disabled)};
    > * {
      color: ${colors.background.regular};
    }
  }

  &:hover:enabled {
    background-color: ${({ color }) => (colors[color]?.darker ?? colors.primary.darker)};
    border-color: ${({ color }) => (colors[color]?.regular ?? colors.primary.hover)};
    
    > * {
      color: ${({ color }) => (colors[color]?.regular ?? colors.primary.hover)};
    }
  }

  &:focus {
    background-color: ${({ color }) => (colors[color]?.darker ?? colors.primary.darker)};
    > * {
      color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
    }
  }

  &:active:enabled {
    background-color: ${({ color }) => (colors[color]?.darker ?? colors.primary.darker)};
    border: 1px solid ${({ color }) => (colors[color]?.selected ?? colors.primary.hover)};
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.12);
    > * {
      color: ${({ color }) => (colors[color]?.regular ?? colors.primary.regular)};
    }
  }
`

export const StyledButton = styled.button`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  align-items: center;

  border-radius: 5px;
  border: none;

  cursor: pointer;
  width: ${({ block }) => (block ? '100%' : 'max-content')};

  ${({ size }) => {
    switch (size) {
      case 'small':
        return Small
      case 'large':
        return Large
      default:
        return Medium
    }
  }};

  ${({ type }) => {
    switch (type) {
      case 'line': return Line
      case 'ghost': return Ghost
      default: return Solid
    }
  }};

  > :not(:last-child) {
    ${({ reverse }) => (reverse ? `margin-left: ${spacing.one}` : `margin-right: ${spacing.one}`)};
  }

  transition: background-color 250ms;

  text-overflow: ellipsis;
  overflow: hidden;
`
